'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var BoxHeader = function (_React$Component) {
    (0, _inherits3.default)(BoxHeader, _React$Component);

    function BoxHeader() {
        (0, _classCallCheck3.default)(this, BoxHeader);
        return (0, _possibleConstructorReturn3.default)(this, (BoxHeader.__proto__ || (0, _getPrototypeOf2.default)(BoxHeader)).apply(this, arguments));
    }

    (0, _createClass3.default)(BoxHeader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                border = _props.border,
                className = _props.className,
                children = _props.children,
                pull = _props.pull,
                title = _props.title,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['border', 'className', 'children', 'pull', 'title']);


            className = (0, _classnames2.default)('box-header', className, { border: border });

            var boxToolsClassName = (0, _classnames2.default)('box-tools', {
                'pull-left': pull === 'left',
                'pull-right': pull === 'right'
            });

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className }, otherProps),
                _react2.default.createElement(
                    'h3',
                    { className: 'box-title' },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: boxToolsClassName },
                    children
                )
            );
        }
    }]);
    return BoxHeader;
}(_react2.default.Component);

BoxHeader.PropTypes = {
    border: _react2.default.PropTypes.bool,
    className: _react2.default.PropTypes.string,
    children: _Utils.COMPONENT_CHILDREN,
    pull: _react2.default.PropTypes.oneOf(['left', 'right']),
    title: _react2.default.PropTypes.string
};
BoxHeader.defaultProps = {
    border: false
};
exports.default = BoxHeader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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